import React, { memo, useEffect, useState } from 'react';
import { mutationTypes } from './mutationUtils';
import { newVerb } from './wordUtils';
import MutationSentences, { WORD_TEMPLATE } from './MutationSentences';
import { Card, CardContent, Grid, TextField } from '@mui/material';
import HelpForInput from './HelpForInput';

const MutationsWithInputForVerb = () => {

  const [ inputText, setInputText ] = useState('');
  const [ verbToMutate, setVerbToMutate ] = useState(newVerb(''));

  const sentencesForVerb = [
    { sentence: `Me <b>a</b> ${WORD_TEMPLATE}.`, mutationType: mutationTypes.SOFT },
    { sentence: `Bara <b>a</b> ${WORD_TEMPLATE} bemdez.`, mutationType: mutationTypes.SOFT },
    { sentence: `Bemdez <b>e</b> ${WORD_TEMPLATE} bara.`, mutationType: mutationTypes.MIXED },
    { sentence: `<b>O</b> ${WORD_TEMPLATE} emaon.`, mutationType: mutationTypes.MIXED },
    { sentence: `<b>Ma</b> ${WORD_TEMPLATE} e vefe un dra vat.`, mutationType: mutationTypes.MIXED },
    { sentence: `Emaon o vont <b>da</b> ${WORD_TEMPLATE}.`, mutationType: mutationTypes.SOFT },
    { sentence: `Skoazell am bo ezhomm <b>da</b> ${WORD_TEMPLATE}.`, mutationType: mutationTypes.SOFT },
    { sentence: `Paouez <b>da</b> ${WORD_TEMPLATE}.`, mutationType: mutationTypes.SOFT },
    { sentence: `<b>Ne</b> ${WORD_TEMPLATE} ket.`, mutationType: mutationTypes.SOFT },
    { sentence: `<b>Na</b> ${WORD_TEMPLATE} ket.`, mutationType: mutationTypes.SOFT },
    { sentence: `Labourat a ra <b>en ur</b> ${WORD_TEMPLATE}.`, mutationType: mutationTypes.SOFT },
    { sentence: `Chom a ran er gêr <b>pa</b> ${WORD_TEMPLATE}.`, mutationType: mutationTypes.SOFT },
    { sentence: `<b>Ra</b> ${WORD_TEMPLATE}!`, mutationType: mutationTypes.SOFT },
    { sentence: `<b>En em</b> ${WORD_TEMPLATE} a rez alies.`, mutationType: mutationTypes.SOFT },
  ];

  useEffect(() => {
    const timeout = setTimeout(() => {
      const copyVerb = verbToMutate.copy();
      copyVerb.sourceContent = inputText;
      console.log('=> setVerbToMutate', inputText);
      setVerbToMutate(copyVerb);
    }, 500);

    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ inputText ]);

  useEffect(() => {
    if (verbToMutate.sourceContent !== inputText) {
      setInputText(verbToMutate.sourceContent);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ verbToMutate ]);

  const handleChangeForVerb = (event) => {
    const target = event.target;

    if (target.name === 'verb-text') {
      setInputText(target.value);
    }
  };

  const sections = [
    {
      words: [
        newVerb('kaout'),
        newVerb('kavout'),
        newVerb('plijout'),
        newVerb('tremen'),
        newVerb('gallout'),
        newVerb('gwiskañ'),
        newVerb('bezañ'),
        newVerb('debriñ'),
        newVerb('dont'),
        newVerb('mont'),
      ],
    },
  ];

  return (
    <section className={'mutation-dynamic-verb'}>
      <Grid container spacing={3}>
        <Grid item xs={12}>

          <Card>
            <CardContent>
              <form name={`mutation-form-verb`} noValidate>
                <div className={'input-with-info'}>
                  <TextField id={`inputVerbToMutate`}
                             variant="standard"
                             label={'Verb'}
                             name="verb-text"
                             value={inputText}
                             onChange={(e) => handleChangeForVerb(e)}
                             fullWidth={true}
                  />
                  <HelpForInput setWordToMutate={setVerbToMutate} sections={sections} title={'Test with a verb'} />
                </div>
              </form>
            </CardContent>
          </Card>
        </Grid>

        {verbToMutate.sourceContent &&
        <Grid item xs={12}>
          <MutationSentences sentences={sentencesForVerb} word={verbToMutate} />
        </Grid>
        }
      </Grid>
    </section>
  );
};

export default memo(MutationsWithInputForVerb);
